import React, { FC } from 'react';
import styles from './filter_dropdown_header.module.scss';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  title: React.ReactElement;
};

export const FilterDropdownHeader: FC<Props> = ({ onClick, title }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      <button onClick={onClick} type="button">
        <MaterialIcon name="close" />
      </button>
    </div>
  );
};
